<template>
  <div class="wrap">
    <transition :name="transitionName">
      <router-view class="content"/>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      transitionName: 'animation'
    }
  },
  methods: {
    // 通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
  // watch: {// 使用watch 监听$router的变化
  //   $route (to, from) {
  //     // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
  //     if (to.meta.index > from.meta.index) {
  //       this.transitionName = 'slide-left'
  //     } else {
  //       this.transitionName = 'slide-right'
  //     }
  //     console.log('topbar', this.transitionName)
  //   }
  // }

}
</script>

<style scoped lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.content{
  position: absolute;
  top:0rem;
  bottom:0;
  left:0;right:0;
  //background-image: linear-gradient(to bottom, #1e4940, #406e51);
  /deep/ .orderButton{
    bottom:1rem !important;
  }
}
& /deep/ .page{
  position: absolute;
  top:3rem;
  bottom:0;
  left:0;right:0;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/blank.vue